// Coresponding with Django OrganizationMember model
const ROLE_ADMIN = 1;
const ROLE_UNDERWRITER = 2;
const ROLE_BROKER = 3;
const ROLE_MANAGER = 4;
const ROLE_BROKER_PARTNER = 5;
const ROLE_ACCOUNT_MANAGER = 6;
const ROLE_ACCOUNT_ASSISTANT = 7;

// Coresponding with Django PolicyMetadata model
const POLICY_METADATA_STATUS_APPROVED = 1;
const POLICY_METADATA_STATUS_FAILED = 2;
const POLICY_METADATA_STATUS_CAUTION = 3;

// Coresponding with Django Workflow model
const WORKFLOW_TYPE_ALL = 1;
const WORKFLOW_TYPE_AUTO = 2;
const WORKFLOW_TYPE_HOME = 3;
const WORKFLOW_TYPE_CONDO = 4;
const WORKFLOW_TYPE_TENANT = 5;
const WORKFLOW_TYPE_BUSINESS = 6;
const WORKFLOW_TYPE_LIFE = 7;
const WORKFLOW_TYPE_TRAVEL = 8;
const WORKFLOW_TYPE_PET = 9;
const WORKFLOW_TYPE_OTHER = 10;

// Coresponding with Django Submission model
const SUBMISSION_TYPE_PERSONAL = 1;
const SUBMISSION_TYPE_COMMERCIAL = 2;
const SUBMISSION_TYPE_LIFE = 3;
const SUBMISSION_TYPE_SPECIALTY = 1;

// Corresponding with Django Policy model
const RUNNER_BIG_AUTO = 1;
const RUNNER_MC_AUTO = 2;
const RUNNER_BIG_HOME = 3;
const RUNNER_BIG_VALIDATE_AUTO_APP = 5;
const RUNNER_BIG_VALIDATE_HOME_APP = 6;
const RUNNER_VALIDATE_AUTO_QUOTE = 7;
const RUNNER_MC_HOME = 8;
const RUNNER_VALIDATE_HOME_QUOTE = 9;
const RUNNER_MC_LIFE = 10;
const RUNNER_LEGACY_AUTO = 11;
const RUNNER_COMMERCIAL_PROPERTY_CASUALTY = 12;
const RUNNER_COMMERCIAL_AUTO = 13;

const PROVINCE_ONTARIO = 1;
const PROVINCE_ALBERTA = 2;
const PROVINCE_NEW_BRUNSWICK = 5;
const PROVINCE_NOVA_SCOTIA = 7;

const ATLANTIC_PROVINCES = [PROVINCE_NEW_BRUNSWICK, PROVINCE_NOVA_SCOTIA];

const isAtlanticProvince = (province: number | undefined): boolean =>
  province !== undefined && ATLANTIC_PROVINCES.includes(province);

// Centralized list of supported MC AUTO provinces
const MC_AUTO_SUPPORTED_PROVINCES = [
  PROVINCE_ONTARIO,
  PROVINCE_ALBERTA,
  PROVINCE_NEW_BRUNSWICK,
  PROVINCE_NOVA_SCOTIA,
];

const isNonOntarioProvince = (province: number | undefined): boolean =>
  province !== undefined &&
  province !== PROVINCE_ONTARIO &&
  MC_AUTO_SUPPORTED_PROVINCES.includes(province);

const CGI_MVR_ENABLED_PROVINCES = [PROVINCE_ONTARIO];

// Validation type string constants
const VALIDATION_TYPE_MC = 'mc';
const VALIDATION_TYPE_MC_HOME = 'mc_home';
const VALIDATION_TYPE_MC_LIFE = 'mc_life';
const VALIDATION_TYPE_VALIDATE_AUTO_QUOTE = 'validate_auto_quote';
const VALIDATION_TYPE_VALIDATE_HOME_QUOTE = 'validate_home_quote';
const VALIDATION_TYPE_LEGACY_AUTO = 'legacy_auto';
const VALIDATION_TYPE_SPECIALTY_AUTO_LOA = 'specialty_auto_loa';
const VALIDATION_TYPE_COMMERCIAL_PROPERTY_CASUALTY =
  'commercial_property_casualty';
const VALIDATION_TYPE_COMMERCIAL_AUTO = 'commercial_auto';

// Corresponding with Django ApplicationFile model
const FILE_TYPE = {
  TYPE_008: {
    text: 'Garaging Declaration (008)',
    type: 1,
  },
  TYPE_040: {
    text: 'Bill of sale (040)',
    type: 2,
  },
  TYPE_UNREPAIRED_DAMAGE: {
    text: 'Unrepaired damage',
    type: 3,
  },
  TYPE_MODIFED_CUSTOMIZED: {
    text: 'Modified / Customized',
    type: 4,
  },
  TYPE_COPY_OF_VEHICLE_OWNERSHIP: {
    text: 'Copy of vehicle ownership',
    type: 5,
  },
  TYPE_DRIVER_TRAINING_CERTIFICATE: {
    text: 'Driver training certificate',
    type: 6,
  },
  TYPE_023: {
    text: "Driver's License History, Driver's Abstract, or Letter of Experience (023)",
    type: 7,
  },
  TYPE_092_110: {
    text: 'Vehicle Photos (4 sides, VIN Plate, VIN Sticker) or Bill of Sale (092, 110)',
    type: 8,
  },
  TYPE_092_110_PHOTOS_ONLY: {
    text: 'Vehicle Photos (4 sides, VIN Plate, VIN Sticker) (092, 110)',
    type: 60,
  },
  TYPE_007: {
    text: "Autoplus Report, DASH Report, or a 'No Policies Found' Screenshot (007)",
    type: 9,
  },
  TYPE_034: {
    text: 'Letter of Experience (034)',
    type: 10,
  },
  TYPE_RETIREE_DISCOUNT_FORM: {
    text: 'Retiree Discount Form',
    type: 11,
  },
  TYPE_GROUP_DISCOUNT_EVIDENCE: {
    text: 'Membership evidence or Group Discount form',
    type: 12,
  },
  TYPE_076: {
    text: 'Winter Tire Invoice (for purchase or installation) (076)',
    type: 13,
  },
  TYPE_090: {
    text: 'Photos of the vehicle (090)',
    type: 14,
  },
  TYPE_097: {
    text: 'Proof of Ownership document (097)',
    type: 15,
  },
  TYPE_108: {
    text: 'Letter of Experience (108)',
    type: 16,
  },
  TYPE_118: {
    text: 'Winter Tire Invoice (Purchase, Installation, or Storage) OR a Photo of Ownership with the Winter Tire (118)',
    type: 17,
  },
  TYPE_121: {
    text: 'Vehicle Photos (4 sides, Windshield VIN, Doorframe VIN) (121)',
    type: 18,
  },
  TYPE_125: {
    text: 'Letter of Experience (LOE) or Autoplus Report (125)',
    type: 19,
  },
  TYPE_127_132: {
    text: 'Bill of Sale / Lease Agreement and Prior Policy Declarations Page (127, 132, 134)',
    type: 20,
  },
  TYPE_133: {
    text: "Driver's License History (DLH) Report (133)",
    type: 21,
  },
  TYPE_032: {
    text: 'Letter of Experience (032)',
    type: 22,
  },
  TYPE_037: {
    text: 'Signed OPCF 49 Endorsement (must be ink signature) (037)',
    type: 23,
  },
  TYPE_043: {
    text: 'Signed OPCF 28/28A Endorsement (must be ink signature) (043)',
    type: 24,
  },
  TYPE_047: {
    text: "Driver's License History Report (047)",
    type: 25,
  },
  TYPE_101: {
    text: "Copy of the reinstated Driver's License (101)",
    type: 26,
  },
  TYPE_VOID_CHEQUE: {
    text: 'Void Cheque (for EFT upload form)',
    type: 27,
  },
  TYPE_FACILITY_REFUSAL_LETTER: {
    text: 'Facility Refusal Letter',
    type: 28,
  },
  TYPE_PRIOR_POLICY_DOCUMENTS: {
    text: 'Policy Renewal Documents',
    type: 29,
  },
  TYPE_524: {
    text: 'Rental Agreement (524)',
    type: 34,
  },
  TYPE_551: {
    text: 'Prior Policy Declarations Page (551)',
    type: 35,
  },
  TYPE_MARKET_APPROVAL_PROPERTY: {
    text: 'Market Approval Documentation (Property)',
    type: 36,
  },
  TYPE_MARKET_APPROVAL_AUTO: {
    text: 'Market Approval Documentation (Auto)',
    type: 37,
  },
  TYPE_124: {
    text: 'Supporting document confirming purchase date (BOS/Lease or AutoPlus) (124)',
    type: 38,
  },
  TYPE_FACILITY_REFUSAL_LETTER_FOR_AUTO: {
    text: 'Facility Refusal Letter for Auto',
    type: 43,
  },
  TYPE_135: {
    text: 'Bill of Sale/Lease Agreement (135)',
    type: 44,
  },
  TYPE_008a: {
    text: 'Proof of Residency (008a)',
    type: 45,
  },
  TYPE_008b: {
    text: 'Proof of Residency (008b)',
    type: 46,
  },
  TYPE_090a: {
    text: 'Photos of the vehicle - Gap in insurance (090a)',
    type: 47,
  },
  TYPE_090b: {
    text: 'Photos of the vehicle - Gap in insurance (090b)',
    type: 48,
  },
  TYPE_560: {
    text: 'Rental Agreement or Policy Declarations Page (560)',
    type: 49,
  },
  TYPE_035: {
    text: 'Vehicle Photos (4 sides, VIN Plate, VIN Sticker) (035)',
    type: 50,
  },
  TYPE_150: {
    text: 'Winter Tire Receipt (Purchase or Installation, less than 6 years old) (150)',
    type: 51,
  },
  TYPE_151: {
    text: 'Facility Winter Tire Declaration (151)',
    type: 52,
  },
  TYPE_561: {
    text: 'Lease Agreement or Prior Property Insurance Declaration Page (561)',
    type: 55,
  },
  TYPE_007a: {
    text: "'No Policies Found' Screenshot (007a)",
    type: 59,
  },
  TYPE_007b: {
    text: "DASH 'No Policies Found' Screenshot (007b)",
    type: 61,
  },
  TYPE_023a: {
    text: "Driver's Abstract (023a)",
    type: 63,
  },
  TYPE_LOE_023a: {
    text: 'Letter of Experience (023a)',
    type: 64,
  },
  TYPE_148: {
    text: 'Vehicle Inspection Report (148)',
    type: 65,
  },
  TYPE_043a: {
    text: 'Signed OPCF 28/28A Endorsement (must be ink signature) (043a)',
    type: 66,
  },
  TYPE_133b: {
    text: "Driver's License History (DLH) and/or Letter of Experience (LOE) (133b)",
    type: 67,
  },
  TYPE_133a: {
    text: "Driver's License History (DLH) Report (133a)",
    type: 68,
  },
  TYPE_043b: {
    text: 'Signed OPCF 28/28A Endorsement (must be ink signature) (043b)',
    type: 69,
  },
  TYPE_147: {
    text: 'Theft Recovery Device Installation Certificate (147)',
    type: 70,
  },
  TYPE_153b: {
    text: 'Vehicle Photos (4 sides, VIN Plate, VIN Sticker) (153b)',
    type: 71,
  },
  TYPE_153b_OSSC: {
    text: 'Ontario Safety Standards Certificate (153b)',
    type: 72,
  },
  TYPE_153a: {
    text: 'Time-Stamped Vehicle Photos (4 sides, VIN Plate, VIN Sticker) (153a)',
    type: 73,
  },
  TYPE_153a_OSSC: {
    text: 'Ontario Safety Standards Certificate (OSSC) (153a)',
    type: 74,
  },
};

// Corresponding with Django ApplicationTextParserSettings model
const AI_TEXT_REMARKS_TYPE_MAPPER = {
  '008': 1,
  '092': 2,
  '040': 3,
  '014': 4,
  '012': 5,
  '013': 6,
  demo_vehicle_odometer_reading: 7,
  '016': 8,
  '076': 9,
  car_pooling: 10,
  unrepaired_damage: 11,
  '017': 11,
  modified_customized: 12,
  ride_sharing: 13,
  registered_vs_actual_owner: 14,
  '007': 15,
  '023': 16,
  '024': 17,
  retiree_discount: 18,
  driver_training_certificate: 19,
  '030': 20,
  '034': 21,
  '032': 22,
  '027': 23,
  '028': 24,
  '029': 25,
  fraud: 26,
  total_vehicles: 27,
  '025': 28,
  '086': 29,
  '090': 30,
  '108': 31,
  '120': 32,
  '126': 33,
  '130': 34,
  '131': 35,
  '026': 36,
  '033': 37,
  '077': 38,
  '087': 39,
  '006': 40,
  group_discount: 41,
  cancellations_last_3_years: 42,
  additional_risk: 43,
  '072': 44,
  '079': 45,
  known_circumstances: 46,
  declined_cancelled_refused_intent_not_to_renew_in_past_5_years: 47,
  '503': 48,
  '549': 49,
  '552': 50,
  '553': 51,
  '555': 52,
  '558': 53,
  mortgagee_name: 54,
  liability_exposures_526: 55,
  liability_exposures_527: 56,
  liability_exposures_528: 57,
  liability_exposures_529: 58,
  liability_exposures_531: 59,
  liability_exposures_532: 60,
  liability_exposures_533: 61,
  liability_exposures_534: 62,
  liability_exposures_535: 63,
  liability_exposures_536: 64,
  liability_exposures_537: 65,
  liability_exposures_538: 66,
  liability_exposures_539: 67,
  liability_exposures_540: 68,
  liability_exposures_541: 69,
  liability_exposures_542: 70,
  liability_exposures_543: 71,
  liability_exposures_544: 72,
  liability_exposures_546: 73,
  '048': 74,
  '122': 75,
  '070': 76,
  '124': 77,
  '098': 78,
  '550': 79,
  '008a': 80,
  '008b': 81,
  '090a': 82,
  '090b': 83,
  used_outside_canada: 84,
  '060': 85,
  '149': 86,
  '035': 87,
  remarks_market_approval: 88,
  '022': 89,
  credit_rating_address: 90,
  '133b': 91,
  '111': 92,
};

// Corresponding with Django ApplicationBinderPDF model
const BINDER_STATUS_GENERATING = 1;
const BINDER_STATUS_COMPLETED = 2;
const BINDER_STATUS_ERROR = 3;
const BINDER_STATUS_REMOVED = 4;

// Corresponding with Django ApplicationSigning model
const SIGNING_STATUS_PENDING = 1;
const SIGNING_STATUS_COMPLETED = 2;
const SIGNING_STATUS_ERROR = 3;
const SIGNING_STATUS_CANCELLED = 4;
const STATUS_PENDING_CANCELLATION = 5;

// WIP Status constants
const WIP_STATUS_VALIDATIONS = 1;
const WIP_STATUS_APPEAL_SUBMITTED = 2;
const WIP_STATUS_APPEAL_APPROVED = 3;
const WIP_STATUS_APPEAL_REJECTED = 4;
const WIP_STATUS_APPLICATION_CREATION = 5;
const WIP_STATUS_DOCUMENT_GENERATION = 6;
const WIP_STATUS_SIGNING_AWAITING_BROKER = 7;
const WIP_STATUS_SIGNING_SEND_FOR_CLIENT = 8;
const WIP_STATUS_COMPLETED = 9;
const WIP_STATUS_EXPIRED = 10;
const WIP_STATUS_BINDER_PENDING_UPLOAD = 11;
const WIP_STATUS_BINDER_UPLOADED = 12;
const WIP_STATUS_BARA_SUBMITTED = 13;
const WIP_STATUS_BARA_UNDER_REVIEW = 14;
const WIP_STATUS_BARA_NEEDS_INFO = 15;
const WIP_STATUS_BARA_APPROVED = 16;
const WIP_STATUS_BARA_DECLINED = 17;
const WIP_STATUS_UW_DECLINED = 18;
const WIP_STATUS_DECLINED = 19;

// Corresponding with Django BaraReferral model constants (bara/models.py)
const BARA_REFERRAL_STATUS_READY_FOR_REVIEW = 1;
const BARA_REFERRAL_STATUS_UNDER_REVIEW = 2;
const BARA_REFERRAL_STATUS_APPROVED = 3;
const BARA_REFERRAL_STATUS_DECLINED = 4;
const BARA_REFERRAL_STATUS_RECALLED = 5;
const BARA_REFERRAL_STATUS_NEEDS_INFO = 6;

const JIRA_BASE_URL = process.env.REACT_APP_BIG_JIRA_BASE_URL || '';

const APPROVED_LENDERS = {
  'ATB Financial': 'AB',
  'All Nations Trust Company': 'All',
  'Assumption Mutual Life Insurance Company': 'PE, NS, NB, QC',
  'Atlantic Central': 'NS, NB, PE',
  'B.C. Housing Management Commission': 'BC',
  'B2B Bank': 'All',
  'BNP Paribas (Canada)': 'All',
  'Bank of China (Canada)': 'AB, BC, ON, QC',
  'Bank of Montreal': 'All',
  'Bank of Montreal Mortgage Corporation': 'All',
  'Bank of Nova Scotia': 'All',
  'Beneva Inc.': 'QC',
  'Bridgewater Bank': 'All',
  'Caisse Desj. Ontario CU Inc.': 'ON',
  'Caisse populaire Alliance ltée': 'ON',
  'CBRE Capital (Canada) Inc.': 'All',
  CMHC: 'All',
  'CMLS Financial Ltd.': 'All',
  'Caisse populaire acadienne Ltée. O/A UNI Financial Cooperation.': 'All',
  'CS Alterna Bank': 'All',
  'CU Central Alberta Ltd.': 'AB',
  'CU Central of Manitoba Ltd.': 'MB',
  'CU Central of Ontario Ltd.': 'ON',
  'CU Central of Saskatchewan': 'SK',
  'Canada ICI Capital Corporation': 'All',
  'Canada Life Assurance Company': 'All',
  'Canadian Mortgage Capital Corporation': 'BC, ON',
  'Canadian Western Bank': 'All',
  'Canadian Western Trust Company': 'All',
  'Canadian Imperial Bank of Commerce': 'All',
  'Central 1 CU': 'BC',
  'CIBC Mortgages Inc. (CMI)': 'All',
  'CIBC Mortgages Inc. / Firstline Mortgages': 'All',
  'CIBC Trust Corporation': 'All',
  'Coast Capital Savings Federal Credit Union': 'All',
  'Community Trust': 'All',
  'Concentra Bank': 'All',
  'Conexus Credit Union': 'All',
  'Cooperators Life Insurance Company': 'All',
  'CP Groupe Financier': 'MB',
  'Desjardins Financial Security': 'All',
  'Effort Trust Company': 'All',
  'Empire Life Insurance Company': 'All',
  'Equitable Life Insurance Company Canada': 'All',
  'Equitable Bank': 'All',
  'Fiducie Desjardins Inc.': 'All',
  'Firm Capital Corporation': 'BC, AB, ON, NS',
  'First National Financial LP': 'All',
  'First National Financial GP': 'All',
  'First National Financial': 'All',
  'First Nations Bank of Canada': 'All',
  'Fédération des caisses Desjardins du Québec*': 'QC',
  'Harbour Mortgage Corp.': 'AB, BC, ON, QC',
  'Haventree Bank': 'NL, PE, NS, NB, QC, ON, MB, SK, AB, BC',
  'Home Bank': 'All',
  'Home Trust Company': 'All',
  'ICICI Bank Canada': 'All',
  'IG Investment Management Ltd.': 'All',
  'Industrial Alliance Insurance & Financial Services Inc.': 'All',
  'Innovation Federal CU': 'AB, BC, MB, NB, NL, NS, NT, NU, ON, PE, SK, YT',
  'Institutional Mortgage Capital Canada Inc.': 'BC, NB, NS, ON, PEI, QC',
  'Institutional Mortgage Servicing Canada Inc.':
    'AB, BC, MB, NB, ON, SK, NS, PE, QC',
  'Intellifi Corporation': 'AB, BC, NB, NL, NS, ON, SK, QC, MB, PEI',
  'Investors Group Trust Company Ltd.': 'All',
  'Investors Syndicate Ltd.': 'All',
  Ivari: 'All',
  'KingSett Mortgage Corporation': 'AB, BC, NS, NU, ON, QC, YT, NT, PEI',
  'Laurentian Bank of Canada': 'All',
  'League Savings & Mortgage Company': 'All',
  'Manitoba Housing and Renewal Corp.': 'MB',
  'Manufacturers Life Insurance Company': 'All',
  'Manulife Bank of Canada': 'All',
  'Manulife Trust Company': 'All',
  'Marathon Mortgage Corp.': 'AB, BC, NB, NL, NS, ON,QC, MB, PE, SK',
  'MCAN Home Mortgage Corporation':
    'NL, PE, NS, NB, ON, MB, SK, AB, BC, YK, NT, NU',
  'MCAP Financial Corporation': 'All',
  'MCAP Service Corporation': 'All',
  'Montrose Mortgage Corporation Ltd.':
    'NL, PE, NS, NB, ON, MB, SK, AB, BC, YK, NT, NU',
  'Motus Bank': 'AB, BC, NB, NL, NU, NS, NWT, ON, MB, PE, SK, YT',
  'National Bank of Canada': 'All',
  'National Trust Company': 'All',
  'Nesto Inc.': 'AB, BC, NB, NL, NS, ON, QC, SK, PEI, MB, NWT, NU, YK',
  'New Brunswick Housing Corporation': 'NB',
  'Newfoundland & Labrador CU Ltd.': 'NL',
  'Omers Administration Corporation': 'ON',
  'Ontario Infrastructure and Lands Corporation': 'ON',
  'Otera Capital Holding Inc.': 'ON,QC',
  'Paradigm Quest Inc.': 'NL, PE, NS, NB, QC, ON, MB, SK, AB, BC',
  'Peace Hills Trust Company': 'All',
  'Peakhill Capital Inc.': 'AB, BC, NS, NL, ON, QC, MB, NB, SK, PEI',
  'Peoples Trust Company': 'All',
  'Radius Financial Inc.': 'NL, PE, NS, NB, QC, ON, MB, SK, AB, BC',
  'Ratehub Inc. (o/a CanWise Financial)':
    'AB, BC, ON, MB, QC, PEI, NS, NB, NL, SK',
  'RBC Life Insurance Company': 'All',
  'RFA Bank of Canada': 'All',
  'RFA Mortgage Corporation': 'AB, BC, NS, ON, PEI, SK, NL, NB, MB',
  'Royal Bank of Canada': 'All',
  'Royal Trust Company': 'All',
  'Scotia Mortgage Corporation': 'All',
  'Simplii Financial': 'All',
  'Société de Fiducie': 'All',
  'Strive Capital Corporation': 'AB, ON, NS, NB, PEI, NL, BC, MB, QC, SK, YK',
  'SBI Canada Bank': 'All',
  'Sun Life Assurance Company Canada': 'All',
  'Tangerine Bank': 'All',
  'Toronto-Dominion Bank': 'All',
  'True North Mortgage Inc. (o/a THINK Financial)':
    'AB, BC, NS, ON, QC, MB, NL, NB, NU, NWT, PEI, YK, SK',
  'Vancity Community Investment Bank': 'All',
  'Vancouver City Savings CU': 'BC',
  VersaBank: 'All',
  'Audi Finance': 'All',
  'BMO Band of Montreal': 'All',
  'BMW Financial Services Canada': 'All',
  'Canadian Dealer Lease Services': 'All',
  'Canadian Imperial Bank of Comm': 'All',
  'Canadian Road Management Co': 'All',
  'Canadian Road Management Company': 'All',
  CIBC: 'All',
  'CIBC Mortgages Inc': 'All',
  'CMH Sales and Leasing': 'All',
  'Computer Trust Co of Canada': 'All',
  'Computer Trust Company of Canada': 'All',
  'Equitable Trust Company': 'All',
  'Ford Credit Canada': 'All',
  'Ford Credit Canada Leasing Ltd': 'All',
  'Ford Credit Canada Leasing Limited': 'All',
  'GM Financial': 'All',
  'Home Trust Co': 'All',
  'Honda Canada Finance Inc': 'All',
  'Honda Canada Finance Incorporated': 'All',
  'Hyundai Capital Canada Inc': 'All',
  'Hyundai Capital Canada Incorporated': 'All',
  'IA Auto Finance': 'All',
  'ING Mortgages': 'All',
  'Libro Credit Union': 'All',
  'MCAP Mortgage Corp': 'All',
  'MCAP Mortgage Corporation': 'All',
  'Mercedes Benz Financial Servic': 'All',
  'Mercedes Benz Financial Services': 'All',
  'Meridian Credit Union': 'All',
  'Motortowne Auto Sales & Leasin': 'All',
  'Motortowne Auto Sales & Leasing': 'All',
  'Nissan Canada Finance': 'All',
  'Royal Bank of Canada (RBC)': 'All',
  RBC: 'All',
  'Scotia Dealer Advantage': 'All',
  Scotiabank: 'All',
  'Scotia bank': 'All',
  'TD Auto Finance Canada Inc': 'All',
  'TD Auto Finance Canada Incorporated': 'All',
  'TD Canada Trust': 'All',
  'TD Financing Services': 'All',
  'The Bank of Nova Scotia': 'All',
  'The Toronto Dominion Bank': 'All',
  'Toyota Credit Canada Inc': 'All',
  'Toyota Credit Canada Incorporated': 'All',
  'VW Credit Canada Inc': 'All',
  'VW Credit Canada Incorporated': 'All',
};

export {
  ROLE_ADMIN,
  ROLE_UNDERWRITER,
  ROLE_BROKER,
  ROLE_MANAGER,
  ROLE_BROKER_PARTNER,
  ROLE_ACCOUNT_MANAGER,
  ROLE_ACCOUNT_ASSISTANT,
  WORKFLOW_TYPE_ALL,
  WORKFLOW_TYPE_AUTO,
  WORKFLOW_TYPE_HOME,
  WORKFLOW_TYPE_CONDO,
  WORKFLOW_TYPE_TENANT,
  WORKFLOW_TYPE_BUSINESS,
  WORKFLOW_TYPE_LIFE,
  WORKFLOW_TYPE_TRAVEL,
  WORKFLOW_TYPE_PET,
  WORKFLOW_TYPE_OTHER,
  POLICY_METADATA_STATUS_APPROVED,
  POLICY_METADATA_STATUS_FAILED,
  POLICY_METADATA_STATUS_CAUTION,
  SUBMISSION_TYPE_PERSONAL,
  SUBMISSION_TYPE_COMMERCIAL,
  SUBMISSION_TYPE_LIFE,
  SUBMISSION_TYPE_SPECIALTY,
  RUNNER_BIG_AUTO,
  RUNNER_MC_AUTO,
  RUNNER_BIG_HOME,
  RUNNER_BIG_VALIDATE_AUTO_APP,
  RUNNER_BIG_VALIDATE_HOME_APP,
  RUNNER_VALIDATE_AUTO_QUOTE,
  RUNNER_MC_HOME,
  RUNNER_VALIDATE_HOME_QUOTE,
  RUNNER_MC_LIFE,
  RUNNER_LEGACY_AUTO,
  RUNNER_COMMERCIAL_PROPERTY_CASUALTY,
  RUNNER_COMMERCIAL_AUTO,
  PROVINCE_ONTARIO,
  PROVINCE_ALBERTA,
  PROVINCE_NEW_BRUNSWICK,
  PROVINCE_NOVA_SCOTIA,
  ATLANTIC_PROVINCES,
  isAtlanticProvince,
  MC_AUTO_SUPPORTED_PROVINCES,
  isNonOntarioProvince,
  CGI_MVR_ENABLED_PROVINCES,
  VALIDATION_TYPE_MC,
  VALIDATION_TYPE_MC_HOME,
  VALIDATION_TYPE_VALIDATE_AUTO_QUOTE,
  VALIDATION_TYPE_VALIDATE_HOME_QUOTE,
  VALIDATION_TYPE_LEGACY_AUTO,
  VALIDATION_TYPE_SPECIALTY_AUTO_LOA,
  VALIDATION_TYPE_MC_LIFE,
  VALIDATION_TYPE_COMMERCIAL_PROPERTY_CASUALTY,
  VALIDATION_TYPE_COMMERCIAL_AUTO,
  FILE_TYPE,
  AI_TEXT_REMARKS_TYPE_MAPPER,
  BINDER_STATUS_GENERATING,
  BINDER_STATUS_COMPLETED,
  BINDER_STATUS_ERROR,
  BINDER_STATUS_REMOVED,
  SIGNING_STATUS_PENDING,
  SIGNING_STATUS_COMPLETED,
  SIGNING_STATUS_ERROR,
  SIGNING_STATUS_CANCELLED,
  STATUS_PENDING_CANCELLATION,
  WIP_STATUS_VALIDATIONS,
  WIP_STATUS_APPEAL_SUBMITTED,
  WIP_STATUS_APPEAL_APPROVED,
  WIP_STATUS_APPEAL_REJECTED,
  WIP_STATUS_APPLICATION_CREATION,
  WIP_STATUS_DOCUMENT_GENERATION,
  WIP_STATUS_SIGNING_AWAITING_BROKER,
  WIP_STATUS_SIGNING_SEND_FOR_CLIENT,
  WIP_STATUS_COMPLETED,
  WIP_STATUS_EXPIRED,
  WIP_STATUS_BINDER_PENDING_UPLOAD,
  WIP_STATUS_BINDER_UPLOADED,
  WIP_STATUS_BARA_SUBMITTED,
  WIP_STATUS_BARA_UNDER_REVIEW,
  WIP_STATUS_BARA_NEEDS_INFO,
  WIP_STATUS_BARA_APPROVED,
  WIP_STATUS_BARA_DECLINED,
  BARA_REFERRAL_STATUS_READY_FOR_REVIEW,
  BARA_REFERRAL_STATUS_UNDER_REVIEW,
  BARA_REFERRAL_STATUS_APPROVED,
  BARA_REFERRAL_STATUS_DECLINED,
  BARA_REFERRAL_STATUS_RECALLED,
  BARA_REFERRAL_STATUS_NEEDS_INFO,
  WIP_STATUS_UW_DECLINED,
  WIP_STATUS_DECLINED,
  JIRA_BASE_URL,
  APPROVED_LENDERS,
};

// Validation IDs that require mandatory file uploads for auto forms
export const AUTO_MANDATORY_FILE_VALIDATIONS = [
  '006',
  '060',
  '017',
  '018',
  '023',
  '023a',
  '032',
  '035',
  '037',
  '043a',
  '043b',
  '040',
  '045',
  '047',
  '074',
  '076',
  '090',
  '092',
  '101',
  '110',
  '118',
  '148',
  '150',
  '151',
  '152',
  '121',
  '124',
  '125',
  '134',
  '135',
  '007a',
  '007b',
  '008a',
  '008b',
  '090a',
  '090b',
  'fainting_spells',
  'medical_condition',
  '147',
  '153b',
  '153b-ossc',
  '153a',
  '153a-ossc',
  'prior_policy_documents',
];

export const HOME_MANDATORY_FILE_VALIDATIONS = [
  '524',
  '551',
  '560',
  '561',
  'prior_policy_documents',
];

export const LOB_PERSONAL_AUTO = 1;
export const LOB_PERSONAL_PROPERTY = 2;
export const LOB_PL_SPECIALTY = 3;
export const LOB_CL_PROPERTY = 4;

export const LINES_OF_BUSINESS = [
  { value: LOB_PERSONAL_AUTO, label: 'Personal Auto' },
  { value: LOB_PERSONAL_PROPERTY, label: 'Personal Property' },
];

export const PROVINCES = [
  { value: 1, label: 'Ontario' },
  { value: 2, label: 'Alberta' },
  { value: 3, label: 'British Columbia' },
  { value: 4, label: 'Manitoba' },
  { value: 5, label: 'New Brunswick' },
  { value: 6, label: 'Newfoundland and Labrador' },
  { value: 7, label: 'Nova Scotia' },
  { value: 8, label: 'Saskatchewan' },
  { value: 9, label: 'Prince Edward Island' },
  { value: 10, label: 'Quebec' },
  { value: 11, label: 'Yukon' },
  { value: 12, label: 'Northwest Territories' },
  { value: 13, label: 'Nunavut' },
];

export const PROVINCE_ID_TO_CODE: Record<number, string> = {
  1: 'ON',
  2: 'AB',
  3: 'BC',
  4: 'MB',
  5: 'NB',
  6: 'NL',
  7: 'NS',
  8: 'SK',
  9: 'PE',
  10: 'QC',
  11: 'YT',
  12: 'NT',
  13: 'NU',
};
